import type { AnnualPlanExportFilters } from '@shared/schema';

export function buildAnnualPlansExportQuery(
  format: 'csv' | 'excel',
  scopeName?: string,
  filters?: AnnualPlanExportFilters,
): string {
  const params = new URLSearchParams({ format });
  if (scopeName) params.set('scopeName', scopeName);

  const entries: Array<[keyof AnnualPlanExportFilters, string | undefined]> = [
    ['hierarchicalModelId', filters?.hierarchicalModelId],
    ['status', filters?.status],
    ['year', filters?.year],
    ['fromDate', filters?.fromDate],
    ['toDate', filters?.toDate],
  ];
  entries.forEach(([key, value]) => {
    if (value) params.set(key, value);
  });

  return params.toString();
}
